import ExperienceCoverImage from '@/components/experiences/experience-cover-image'
import ExperienceDuration from '@/components/experiences/experience-duration'
import ExperienceFromPrice from '@/components/experiences/experience-from-price'
import ExperienceRate from '@/components/experiences/experience-rate'
import { Experience } from '@/types'
import { stripHtml } from '@/lib/html-utils'
import Link from 'next/link'
import { useRouter } from 'next/router'

const AppExperienceCard = ({ experience }: { experience: Experience }) => {
  const router = useRouter()

  return (
    <div className="relative duration-150 hover:-translate-y-2">
      <ExperienceCoverImage experience={experience} />

      <div className="card__heading mt-2 flex flex-col justify-between">
        <Link
          className="text-base font-semibold hover:text-primary line-clamp-2 h-12"
          href={`/app/widgets/${router.query.widgetUuid}/experiences/${experience.uuid}`}
          aria-label={experience.name}
        >
          {experience.name}
        </Link>

        <div className="flex my-1 justify-between">
          <ExperienceDuration option={experience.options[0]} />

          <ExperienceRate experience={experience} />
        </div>

        <div className="line-clamp-3 text-sm text-muted-foreground min-h-10">
          {stripHtml(experience.highlight)}
        </div>

        <div className="text-sm font-semibold mt-2">
          <ExperienceFromPrice experience={experience} />
        </div>
      </div>
    </div>
  )
}

export default AppExperienceCard
